import styles from './DigitalPoC.module.scss'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const tweenVars: gsap.TweenVars = {
  y: '50',
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const DigitalPoC: React.FC = () => {
  const timeline = gsap.timeline()
  const EN_title = useRef<HTMLDivElement>(null)
  const JP_title = useRef<HTMLDivElement>(null)
  const text = useRef<HTMLDivElement>(null)
  const img = useRef<HTMLImageElement>(null)
  const supports = useRef<HTMLDivElement[]>([])

  useEffect(() => {
    timeline
      .from(img.current, tweenVars, 0.1)
      .from(EN_title.current, tweenVars, 0.1)
      .from(JP_title.current, tweenVars, 0.3)
      .from(text.current, tweenVars, 0.5)

    // 最初の要素を早く出す

    // 残りの要素をstaggerで順番にアニメーションさせる
    timeline.from(supports.current, {
      ...tweenVars,
      stagger: 0.2,
    })

    ScrollTrigger.create({
      animation: timeline,
      trigger: EN_title.current,
      start: 'top-=150 80%',
      toggleActions: 'play none none reverse',
    })

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
      timeline.kill()
    }
  }, [])
  const services = [
    {
      href: '/services/aidd/',
      title: '特徴量エンジニアリングと生成AI',
      body: '生成AIに特徴エンジニアリングを適用したUI生成のR&Dに取り組んでいます。限られたデータでも、期待にそったアウトプットを生成AIから出力が可能です。',
    },
  ]

  return (
    <section className={styles.contents} id='degital-poc'>
      <div className={styles.head}>
        <figure className={styles.head_icon}>
          <img ref={img} src="/images/icons/icon_digital_poc.svg" alt="Digital PoC" />
        </figure>
        <div className={styles.head_title}>
          <h2 ref={EN_title} className={styles.head_title_en}>
            Digital PoC
          </h2>
          <h3 ref={JP_title} className={styles.head_title_ja}>
            デジタルPoC
          </h3>
        </div>
      </div>
      <p ref={text} className={styles.head_title_text}>
        特徴量エンジニアリング、生成AI（RAG）、機械学習の社内導入、メタバースやAR/VRといったxR技術を用いた新たなコミュニケーション分野の開拓など、最新テクノロジーを導入するためのPoCサービスを提供します。
      </p>
      <div className={styles.supports}>
        {services.map((service, index) => (
          <div key={index} ref={(el) => (supports.current[index] = el)} className={styles.support}>
            <a href={service.href}>
              <div className={styles.wrapper}>
                <span className={styles.dot}></span>
                <div className={styles.textWrapper}>
                  <h4 className={styles.title}>{service.title}</h4>
                  <p className={styles.description}>{service.body}</p>
                </div>
              </div>
              <span className={styles.viewmore}>Read more</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  )
}

export default DigitalPoC
